import Icon from "@chakra-ui/icon";
import { forwardRef, IconProps } from "@chakra-ui/react";
import React from "react";

export const NarrowIcon = forwardRef<IconProps, "svg">((props, ref) => (
    <Icon ref={ref} viewBox="0 0 14 14" fill="transparent" {...props}>
        <g clipPath="url(#clip0_947_709)">
            <path d="M5.54199 13.4587L13.4587 5.54199" stroke="#222C63" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.54199 5.54199H13.4587V13.4587" stroke="#222C63" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_947_709">
                <rect width="19" height="19" fill="white"/>
            </clipPath>
        </defs>
    </Icon>
));